import { InvoiceUpdateStepName } from 'app/src/features/Shopping/Refund/components/RefundFunctions'
import type { StatusCheckerInfoBundleType, WizardStepConfigType } from 'app/src/features/Shopping/shared/types'
import { shoppingApi, type portalConfigurationApi } from 'app/src/services/welfareportal'
import type { WebAppContextType } from 'app/src/shared/helpers'

export const LeftSideDefaultClassName =
  'col-span-12 flex flex-wrap justify-center gap-10 p-2 lg:col-span-6 lg:justify-center lg:pr-8'

export const RightSideDefaultClassName =
  'col-span-12 grid-cols-12 mx-auto grid w-full justify-center p-2 lg:col-span-6 lg:justify-start lg:pl-8'
export function BuildBeneficiaries(order: shoppingApi.OrderDetails) {
  let beneficiariEstratti: string = ''

  if (!order.beneficiaries?.familyMembers || order.beneficiaries.familyMembers.length == 0) {
    beneficiariEstratti = order.userInfo?.firstName + ' ' + order.userInfo?.lastName
  } else {
    if (order.beneficiaries.user && order.userInfo) {
      beneficiariEstratti = order.userInfo.firstName + ' ' + order.userInfo.lastName + '; '
    }

    beneficiariEstratti += order.beneficiaries.familyMembers.map((x) => x.firstName + ' ' + x.lastName).join(';')
  }

  return beneficiariEstratti
}

export enum CardPurchaseStatus {
  DRAFT = 0,
  INPROGRESS = 1,
  TAKEINCHARGE = 2,
  COMPLETED = 3,
  USED = 4,
  DONE = 5,
  CANCELED = 6,
  FAILED = -1,
}
export type CardPurchaseData = { status: CardPurchaseStatus; order: shoppingApi.OrderDetails }

export type CardInProgressViewBaseProps = {
  purchaseData: CardPurchaseData
  setPurchaseData: (data: CardPurchaseData) => void
}

export const cardPollingWorker = async (
  purchaseData: CardPurchaseData,
  shoppingConfig: Required<portalConfigurationApi.ShoppingConfig['cardPolling']>,
  context: WebAppContextType,
): Promise<CardPurchaseData> => {
  let orderDetailsResponse: shoppingApi.OrderDetails | undefined = undefined
  let purchaseStatus: CardPurchaseStatus = CardPurchaseStatus.INPROGRESS
  let attemptCount = 0
  while (purchaseStatus === CardPurchaseStatus.INPROGRESS && attemptCount < shoppingConfig!.cardTakeInChargeMaxCount) {
    try {
      orderDetailsResponse = await shoppingApi.fetchOrderGet({ pathParams: { orderId: purchaseData.order.orderId } })
    } catch (err) {
      context.logger?.error('Error While Polling Order', { orderId: purchaseData.order.orderId, error: err })
      //Polling error -> TAKE IN CHARGE
      return { status: CardPurchaseStatus.TAKEINCHARGE, order: purchaseData.order }
    }
    attemptCount++
    //GESTIONE CALLBACK
    switch (orderDetailsResponse.status) {
      case 'confirmed':
        purchaseStatus = CardPurchaseStatus.COMPLETED
        break
      case 'done':
        purchaseStatus = CardPurchaseStatus.DONE
        break
      case 'rejected':
        purchaseStatus = CardPurchaseStatus.FAILED
        break
      default:
        purchaseStatus = CardPurchaseStatus.INPROGRESS
        break
    }
    await new Promise((resolve) => setTimeout(resolve, shoppingConfig!.cardPollingInterval))
  }
  if (purchaseStatus === CardPurchaseStatus.INPROGRESS) purchaseStatus = CardPurchaseStatus.TAKEINCHARGE
  return { status: purchaseStatus, order: orderDetailsResponse ?? purchaseData.order }
}

export function getCardPurchaseStatus(order: shoppingApi.OrderDetails) {
  let purchaseStatus: CardPurchaseStatus
  switch (order?.status) {
    case 'draft':
      purchaseStatus = CardPurchaseStatus.DRAFT
      break
    case 'started':
    case 'in-progress':
      purchaseStatus = CardPurchaseStatus.INPROGRESS
      break
    case 'confirmed':
      purchaseStatus = CardPurchaseStatus.COMPLETED
      break
    case 'used':
      purchaseStatus = CardPurchaseStatus.USED
      break
    case 'done':
      purchaseStatus = CardPurchaseStatus.DONE
      break
    case 'canceled':
      purchaseStatus = CardPurchaseStatus.CANCELED
      break
    case 'rejected':
    default:
      purchaseStatus = CardPurchaseStatus.FAILED
      break
  }
  return purchaseStatus
}

export const fileStatusChecker = (step: WizardStepConfigType, checkerBundleInfo: StatusCheckerInfoBundleType) => {
  if (!step?.documentAttributes || step.documentAttributes.min === 0) return true
  else {
    const stepFilesToCheck = checkerBundleInfo?.filesToCheck?.find((x) => x.stepName === step.stepName)?.files
    if (!stepFilesToCheck || stepFilesToCheck.length === 0) return false
    else {
      return (
        stepFilesToCheck.length >= (step?.documentAttributes.min ?? 0) && stepFilesToCheck?.length <= step.documentAttributes.max
      )
    }
  }
}

export const checkVoucherEnough = (_step: WizardStepConfigType, checkerBundleInfo: StatusCheckerInfoBundleType) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (checkerBundleInfo.formData as any)[checkerBundleInfo.wizardSteps?.findIndex((x) => x.stepName === InvoiceUpdateStepName)]
      .requestedRefundNumber <= (checkerBundleInfo.selectedVoucherInfo?.total ?? 0)
  )
}
export const REGEX_Importo = /^\d{1,}(?:[,]\d{1,2})?$/g
export const REGEX_FC = /^[A-Z]{6}[0-9]{2}[A-E][0-9]{2}[A-Z][0-9]{3}[A-Z]$/

export const a11yAppBarParams = {
  test: 'error',
  config: {
    rules: [
      {
        id: 'tabindex',
        reviewOnFail: true,
      },
      {
        id: 'focusable-content',
        reviewOnFail: true,
      },
      {
        id: 'label',
        reviewOnFail: true,
      },
      {
        id: 'keyboard',
        reviewOnFail: true,
      },
    ],
  },
}

export const getMealVouchersAccessToken = (context: WebAppContextType) => {
  return context.mealVouchers?.loginInfo?.accessToken ?? ''
}

export const getMealVouchersCompanyCode = (context: WebAppContextType) => {
  return context.mealVouchers?.loginInfo?.companyCode ?? ''
}

export const getMealVouchersUserId = (context: WebAppContextType) => {
  return context.mealVouchers?.loginInfo?.userId ?? ''
}
